import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';
import { url } from '../configlink';

const DownloadBox = () => {
    let loc = useLocation();
    let type = loc.search.split('=')[2].split('&')[0]
    let orderNum = parseInt(loc.search.split("&")[0].split('=')[1]) + 600000;
    let userId = loc.search.split('=')[3]

    // console.log(type);
    

    // const token = localStorage.getItem("token");

    let [files, setFiles] = useState([])

    useEffect(() => {
            fetch(`${url}/api/orderForm/getUserOrderFiles?orderId=${orderNum}&type=${type}&userId=${userId}`, {
                method: "GET",
                credentials: 'include',
                // headers: {
                //     Authorization: `Bearer ${token}`,
                // },
                })
                .then(response => response.json())
                .then(data => setFiles(data))
                .catch(error => console.error('Error fetching files:', error));
       
    }, [])

    // console.log(files);
    


  return (
    <div className='flex flex-col justify-start items-center mt-10'>
        {type === 'invoice' ? 
        <div className='flex flex-col items-center w-3/4 h-auto'>
            <h1 className="text-lg font-extrabold text-[var(--color-primary-purple)]">Invoice for Order Number #{orderNum}</h1>
            <div className='border-1 border-black mt-5 min-h-[150px] w-[80%]'>
                <div className='text-center'>
                    {files && files.length>0 ? files.map((fileName, index) => (
                        <button className='border border-1 border-gray-500 w-full p-1' key={index}>
                            <a 
                            className="text-blue-500" 
                            href={`/invoicefile/${userId}/${fileName.InvoiceFiles}`} 
                            download={fileName.InvoiceFiles}
                            >
                            Download {fileName.InvoiceFiles}
                            </a>
                        </button>
                    )) : (
                        <h1 className='text-red-500 text-sm'>No files to download</h1>
                    )
                    }
                </div>
            </div>
        </div>
        :
        <div className='flex flex-col items-center w-3/4 h-auto'>
        <h1 className="text-lg font-extrabold text-[var(--color-primary-purple)]">Data for Order Number #{orderNum}</h1>
        <div className='border-1 border-black mt-5 min-h-[150px] w-[80%]'>
            <div className='text-center'>
                {files && files.length>0 ? files.map((fileName, index) => (
                    <button className='border border-1 border-gray-500 w-full p-1' key={index}>
                    <a 
                    className='text-blue-500' 
                    href={`/researchfile/${userId}/${fileName.FileName}`} 
                    download={fileName.FileName}
                    >
                        Download {fileName.FileName}
                    </a>
                    </button>
                )) : (

                    <h1 className='text-red-600 text-sm font-bold mt-3'>No files to download yet. <br/> Check again later</h1>
                )
                }
            </div>
        </div>
    </div>
        }

        <button onClick={() => window.close()} className='text-sm mt-10 w-[130px] text-center text-[var(--color-primary-purple)] p-1 rounded-md font-bold bg-gray-200'>Close Window</button>    
        
    </div>
  )
}

export default DownloadBox
